<template>
    <ion-toolbar>
        <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button @click="skip" class="pill next-pill-button">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Availability</h1>
                    <div class="title">
                        <span>What is your availability to work?</span>
                        
                    </div>
                   
                </div>
                <div class="brand-icon" >
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                </div>
            </div>
            <el-button size="small" class="select-all" :type="'link'" @click="toggleSelection"
            :disabled="!isToggleEnabled">{{ isAllSelected ? 'Unselect All' : 'Select All' }}</el-button>
            <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
                :ref="el => formsData.userForm.ref = el" :label-position="'top'" @submit.prevent="goNext('userForm')">
                <el-form-item prop="schedule" class="job_filters_form_checkbox">
                    <div class="item-select__header">
                        <div class="item-select__title">Days</div>
                    </div>
                    <div class="checkbox-availability">
                        <el-checkbox class="checkbox_w100" v-for="(value, day) in formsData.userForm.schedule.value" :key="day"
                            v-model="formsData.userForm.schedule.value[day]">{{ $filters.capitalize(day) }}</el-checkbox>
                    </div>
                </el-form-item>
                <el-form-item class="button_submit mb0">
                    <el-button class="submit_page w-100" type="blue" @click="goNext('userForm')"
                        :disabled="formsData.userForm.disabled">
                        Continue
                         <!-- <i class="el-icon-right"></i> -->
                    </el-button>
                </el-form-item>
            </el-form>
            <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
            </div>
        </div>
    </div>
</template>


<script>
    import {
        onMounted,
        inject,
        computed
    } from 'vue';

    import {
        addIcons
    } from 'ionicons'
    import {
        arrowBackOutline
    } from 'ionicons/icons'
    addIcons({
        'arrow-back-outline': arrowBackOutline
    })
    import {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
    } from '@ionic/vue';

    import {
        useStore
    } from 'vuex'
    import {
        useRouter,
        useRoute
    } from 'vue-router'
    import formHooks from '@/hooks/form/form'
    import formValidate from '@/hooks/form/validate/validate'
    import { ElMessageBox } from "@/components/Vendor/Element";
    import SvgIcon from '@/components/Svg/SvgIcon.vue';


    export default {
        components: {
            IonToolbar,
            IonButton,
            IonButtons,
            IonIcon,
            SvgIcon,
        },
        directives: {
        },
        setup() {
            const $store = useStore()
            const $router = useRouter()
            const $route = useRoute()
            const setPageClassGlobal = inject('setPageClassGlobal');

            const userData = $store.getters.GET_USER_DATA;
            const schedule = userData.schedule;

            console.log($store.getters.getJobFilters.schedule);


            const formsDataArray = {
                userForm: {
                    schedule: {
                        value: $store.getters.getJobFilters.schedule || Object.keys(schedule).reduce((value, key) => {
                            value[key] = !!parseInt(schedule[key]);
                            return value;
                        }, {}),
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'schedule', callback, setFormValidation);
                            },
                        }],
                    },
                }
            };

             // Computed property to check if all checkboxes are selected
            const isAllSelected = computed(() =>
                Object.values(formsData.userForm.schedule.value).every((value) => value === true)
            );

            // Computed property to check if toggling is enabled
            const isToggleEnabled = computed(() =>
                Object.values(formsData.userForm.schedule.value).some((value) => value === false) ||
                isAllSelected.value
            );

            const toggleSelection = () => {
                const selectAll = !isAllSelected.value;
                for (let key in formsData.userForm.schedule.value) {
                    formsData.userForm.schedule.value[key] = selectAll;
                }
                // for (let value in formsData.userForm.schedule.value) {
                //     formsData.userForm.schedule.value[value] = true;
                // }
            }

            const goBack = async() => {
                const back = await $store.dispatch("getAuthPageBack");
                $router.push({
                    name: back,
                });  
            };

            const goNext = (formName) => {
                formsRefs[formName].value.validate((valid) => {
                    if (valid) {

                        (async () => {
                            try {
                                await $store.dispatch('SAVE_USER_DATA', getFormValues(formName));
                                await $store.dispatch('setJobFiltersData', getFormValues(formName));
                                $store.dispatch('addAuthPageBack', $route.name);
                                $router.push({
                                    name: 'auth_preferred_state',
                                })
                            } catch (error) {
                                console.log('error submit!!');
                            }
                        })();
                        console.log('submit!!',getFormValues(formName));
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            };

            const skip = () => {
            (async () => {
                try {
                    await ElMessageBox.confirm(
                        ``,
                        "Do you want to skip? You will be unverified",
                        {
                            distinguishCancelAndClose: true,
                            showConfirmButton: true,
                            confirmButtonText: "Skip",
                            cancelButtonText: "Cancel",
                            confirmButtonClass: "el-button--green",
                            cancelButtonClass: "el-button--grey",
                            showClose: true,
                        }
                    );
                } catch {
                    return;
                }
                try {
                    $store.dispatch('addAuthPageBack', $route.name);
                    $router.push({
                        name: 'auth_preferred_state',
                    })
                } catch (error) {
                    console.log(error);
                }
            })();
          
        }

            onMounted(() => {
                setPageClassGlobal('global_auth_availability_page');
                setFormRefs();
                checkFormValidation('userForm', false);
            });

            const {
                onFormMaskAccept,
                checkFormValidation,
                setFormValidation,
                getFormValues,
                setFormRefs,
                formsData,
                formsRefs,
            } = formHooks(formsDataArray);

            return {
                formsData,
                onFormMaskAccept,
                checkFormValidation,
                setFormValidation,
                goBack,
                goNext,
                toggleSelection,
                skip,
                isAllSelected,
                isToggleEnabled,
            }
        },
    }
</script>